// src/App.js
import "./App.css";
import QRDisplay from "./components/QRDisplay";
import AdminEditor from "./components/AdminEditor";
import { Authenticator } from "@aws-amplify/ui-react";

const currentMonthKey = new Date().toISOString().slice(0, 7); // "YYYY-MM"

export default function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const isAdminRoute = path.startsWith("/admin");

  return (
    <Authenticator>
      {({ signOut, user }) => (
        <div className="App">
          {isAdminRoute ? (
            <div className="admin-card">
              <h1 className="admin-title">Admin Console</h1>
              <p className="admin-subtitle">
                Signed in as <b>{user?.username || user?.attributes?.email}</b>
              </p>

              <AdminEditor />

              <div className="admin-actions" style={{ justifyContent: "flex-end", marginTop: 10 }}>
                <button className="btn" onClick={signOut}>Sign out</button>
              </div>
            </div>
          ) : (
            <>
              <p>Hello, <b>{user?.username || user?.attributes?.email}</b> welcome to BCSW Amarra</p>
              <QRDisplay monthKey={currentMonthKey} />
              <div className="admin-actions" style={{ justifyContent: "center", marginTop: 12 }}>
                <button className="btn" onClick={signOut}>Sign out</button>
              </div>
            </>
          )}
        </div>
      )}
    </Authenticator>
  );
}
